<template>
  <div class="result-wrap">
    <ResultPersonInfo v-if="showCommiter" />
    <template v-if="$route.query.questionActiveKey === '8b7df19453e3450284693b04e17ad278'
      ">
      <div class="result">
        <div style="height: 200px" class="none-img"></div>
      </div>

      <p style="color: #fff" class="text">您的投诉线索已提交！</p>
      <Button class="finish-btn" @click="handleJump2Home">完成</Button>
      <img v-if="lotteryUrl" @click="handleLotteryClick" class="gifts animate__animated animate__fadeIn"
        src="@/assets/img/gifts.png" alt="" />
    </template>
    <template v-else>
      <div class="result">
        <img class="none-img" :src="$store.getters.getResultTipImg" alt="" />
      </div>
      <p class="result-tips">{{ $store.getters.getResultTipText }}</p>
      <Button class="finish-btn" @click="handleJump2Home">{{
      $store.getters.getFinishBtnText
    }}</Button>
      <img v-if="lotteryUrl" @click="handleLotteryClick" class="gifts animate__animated animate__fadeIn"
        src="@/assets/img/gifts.png" alt="" />
    </template>
    <Pay v-if="showPay" @payFinish="showPay = false" />
    <CertificateDialog v-if="showCertificate" @close="showCertificate = false" />
  </div>
</template>

<script>
import { Button, Dialog, Toast } from 'vant'
import { ref, reactive, watchEffect, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { getQueryString } from '@/utils/tools'
import { getResult } from '@/api/index'
import qs from 'qs'
import { useRoute, useRouter } from 'vue-router'
import ResultPersonInfo from '@/components/resultPersonInfo/index.vue'
import { useCommiterInfo, useCertificateDialog } from '@/hooks/index.js'
import { useCommonLotteryEffect } from '@/effects/lotteryClickEffect'
import { QUES_KEY_2023_4_12, PAY_ORIGIN_SYSTEM_ID } from '@/constants'
import CertificateDialog from '@/components/certificateDialog/index.vue'
import WxMiniProgram from '@/components/wxMiniProgram/index.vue'
import Pay from '@/components/pay/index.vue'
import { WebBridgeApi } from 'ijsbridge'

// 获取考试结果
const resultInfoEffect = () => {
  const lotteryUrl = ref('')
  const resInfo = reactive({
    lotteryUrl: '',
  })

  const getResultInfo = async () => {
    const res = await getResult(
      qs.stringify({
        questionActiveKey: getQueryString('questionActiveKey'),
        answerGroupKey: getQueryString('answerGroupKey'),
        type: 1,
        token: getQueryString('token'),
      })
    )
    if (res.ok) {
      lotteryUrl.value = res.data.lotteryUrl
      resInfo.lotteryUrl = res.data.lotteryUrl
    } else {
      Dialog({ message: res.comment })
    }
  }

  getResultInfo()

  return {
    lotteryUrl,
    resInfo,
  }
}

export default {
  components: { Button, ResultPersonInfo, CertificateDialog, Pay },
  setup() {
    const { lotteryUrl, resInfo } = resultInfoEffect()
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    watchEffect(() => {
      console.log('resInfo', resInfo)
    })

    const isBlock = () => {
      // 后台设置样式的时候不做任何响应
      const isSetting = getQueryString('isSetting')
      console.log('isSetting', isSetting)
      if (isSetting) {
        return true
      }
      return false
    }

    const handleJump2Home = () => {
      if (isBlock()) {
        return
      }

      window.history.length > 1
        ? router.go(-1)
        : router.push({
          path: '/',
          query: route.query,
        })
    }

    // 抽奖点击
    const { handleLotteryClick } = useCommonLotteryEffect(resInfo)

    const { showCommiter } = useCommiterInfo()

    // 获取证书弹窗状态
    const { showCertificate } = useCertificateDialog()

    // 支付弹窗
    const showPay = ref(false)

    onMounted(() => {
      const orderSn = route.query.orderSn
      if (orderSn) {
        showPay.value = true
      }
    })


    return {
      lotteryUrl,
      handleLotteryClick,
      handleJump2Home,
      showCommiter,
      showCertificate,
      QUES_KEY_2023_4_12,
      showPay
    }
  },
}
</script>
<style lang="scss" scoped>
.result-wrap {
  min-height: 100vh;
}

.result {
  .none-img {
    display: block;
    padding-top: 80px;
    margin: 0 auto;
    width: 558px;
    height: 499px;
  }
}

.result-tips {
  margin: 0;
  margin-top: 30px;
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: #333333;
  line-height: 1.4;
}

.gifts {
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  width: 689px;
  height: 210px;
}

.finish-btn {
  margin: 0 auto;
  margin-top: 190px;
  display: block;
  width: 598px;
  height: 88px;
  background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
  border-radius: 44px;
  font-size: 34px;
  font-weight: 500;
  color: #ffffff;
}
</style>
